module.exports = __webpack_public_path__ + "img/cluster.3ff2f7c6.svg";